import { createPinia } from 'pinia'
import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";

import './assets/css/main.css';

import { msalPlugin } from './plugins/msalPlugin'
import { msalInstance } from "./services/auth";

const app = createApp(App)

app.use(createPinia())
app.use(router)

app.use(msalPlugin, msalInstance);

app.mount('#app')